<ng-template #issuesTemplate let-item>
	<div class="whitespace-nowrap">{{ item }}</div>
</ng-template>

<div class="flex justify-between bg-grey-veryLight mb-3 p-2">
	<app-button [icon]="ICON.BACK" size="small" (click)="beforeClose()"
		>Back to file</app-button
	>
	<div class="flex items-center">
		<atomic-matter-type-icon
			[fileType]="matter?.fileType"
		></atomic-matter-type-icon>
		<span class="mx-3">{{ matter.number }}</span>
		<span>{{ matter.name }}</span>
	</div>
</div>

<div *ngIf="url && !loading && !errorMessage_()" class="flex flex-1 flex-col">
	<atomic-message-bar
		*ngIf="
			readOnlyMode && issues?.length === 0 && !hasAmendments && !otherUserLocked
		"
		type="warn"
		class="mb-3"
	>
		Currently viewing in <span class="font-bold mx-2">READONLY MODE</span>
	</atomic-message-bar>
	<atomic-message-bar
		*ngIf="readOnlyMode && otherUserLocked"
		type="warn"
		class="mb-3"
	>
		Currently viewing in <span class="font-bold mx-2">READONLY MODE</span> -
		<a
			emailLinkInterceptor
			[mailto]="otherUserLockedEmail"
			class="font-bold underline"
			>{{ otherUserLockedName }}</a
		>
		is also viewing these instructions within the LLC portal. To gain full
		access, have this user close his/her session in the portal and then reopen
		the instructions.
	</atomic-message-bar>
	<atomic-message-bar
		*ngIf="readOnlyMode && issues?.length > 0"
		type="warn"
		class="mb-3"
	>
		<div class="flex">
			<span>
				Currently viewing in readonly mode. Complete matter details to view in
				full access mode.
			</span>
			<div
				class="flex flex-col ml-2"
				(mouseover)="showIssues = true"
				(mouseout)="showIssues = false"
			>
				<div>
					<span class="underline cursor-pointer"
						>{{ issues.length }} issue(s)</span
					>
					<app-icon [icon]="ICON.DOWN" class="text-xs ml-1"></app-icon>
				</div>
				<div class="relative">
					<app-dropdown-options
						xposition="left"
						[show]="showIssues"
						[itemGroups]="[{ items: issues, template: issuesTemplate }]"
					></app-dropdown-options>
				</div>
			</div>
		</div>
	</atomic-message-bar>
	<atomic-message-bar type="warn" class="mb-3" *ngIf="hasAmendments">
		<div class="flex">
			Currently viewing in <span class="font-bold mx-2">READONLY MODE</span> as
			there are amendments that needed to be accepted.
			<span
				class="ml-2 underline cursor-pointer text-green"
				(click)="viewAmendments()"
				>View Amendments</span
			>
		</div>
	</atomic-message-bar>
	<iframe
		id="llc-portal-iframe"
		[src]="url"
		width="100%"
		height="100%"
		class="flex flex-1"
	></iframe>
</div>

<div
	*ngIf="loading && !errorMessage_()"
	class="flex flex-1 justify-center items-center h-full"
>
	<app-icon [icon]="ICON.LOADING" [spin]="true" class="mr-3"></app-icon>
	{{ loadingText }}
</div>

<div
	*ngIf="errorMessage_() && !loading"
	class="flex flex-1 justify-center items-center h-full"
>
	<span>{{ errorMessage_() }}</span>
</div>

<div
	*ngIf="fetchStatusError && !loading"
	class="flex flex-1 justify-center items-center h-full"
>
	<span>
		Unable to update mortgage status. Please refresh the page to get any status
		updates
	</span>
</div>
